var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"emd-progress-bar",style:(_vm.progressBarStyles)},'div',_vm.computedAttrs,false),[(_vm.$slots.default)?[_vm._t("default")]:(_vm.showProgress)?[_vm._v(" "+_vm._s(_vm.computedProgress)+" ")]:(_vm.showValue)?[_vm._v(" "+_vm._s(_vm.computedValue)+" ")]:[_vm._v(" "+_vm._s(_vm.label)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }